module.exports = __webpack_public_path__ + "img/step_m.33508d31.png";